import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ContainerScreenGeneral } from "../../../components";
import { UserContext } from "../../../context";
import { menuButtonsAdmin } from "./menuConfig";

const MenuAdmin = () => {
  const nav = useNavigate();
  const { actions } = useContext(UserContext);

  const hasRoleOrPermission = (button) => {
    // si el usuario logueado tiene el rol o permiso del boton puede verlo
    let act = false;
    if (button.roles) {

      act = button.roles.some((role) => actions.hasRole(role));
    }
    if (act) {
      return act;
    }
    if (button.permissions) {


      act = button.permissions.some((permission) => actions.hasPermission(permission));
    }
    return act;
  };
  // console.log(menuButtonsAdmin);

  return (
    <ContainerScreenGeneral titulo={"Menu Admin"} linkBack={"/"}>
      <div className="bg-body p-3 rounded">
        <div className="d-flex justify-content-center col-12 mx-auto align-items-start p-4">
          <div className="bg-white col-6 row gap-2 m-0">
            {menuButtonsAdmin
              .filter((button) => hasRoleOrPermission(button))
              .map((button, index) => (
                <section key={index} className="d-flex flex-column gap-3 col-12">
                  <button
                    className={`btn btn-primary btn-menu col-9 p-3 d-flex justify-content-start gap-2 align-items-center mx-auto`}
                    onClick={() => nav(button.path)}
                  >
                    {button.icon} {button.label}
                  </button>
                </section>
              ))}
          </div>
        </div>
      </div>
    </ContainerScreenGeneral>
  );
};
export default MenuAdmin;
